<template>
  <div>
    <button title="Show details" @click="openModal()" class="btn-outline-light">
      <i class="fa-regular fa-eye"></i>
    </button>
    
    <!-- modal bulk import -->
    <div class="modal-container" v-if="isModalOpen">
      <div class="modal-content">
        <h1>Order Details<i @click="closeModal()" class="fa-regular fa-xmark"></i></h1>
        <span style="font-weight: normal; color: #717182; justify-content: baseline; display: flex;">Order {{ this.order.Invoices[0] ? this.order.Invoices[0].InvoiceIdentifier : '' }}</span>
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
          <div style="display: grid; gap: 1rem;">
            <span style="display: flex; justify-content: baseline; font-weight: bold; font-size: 1.1rem;">Order Information</span>
            <div style="display: flex; justify-content: space-between;">
              <span style="color: #6a7282;">Reference:</span>
              <span v-if="this.order.Invoices[0]">{{ this.order.Invoices[0].InvoiceIdentifier }}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span style="color: #6a7282;">Amount:</span>
              <span style="font-weight: bold;">€{{ Number(this.order.Amount).toFixed(2) }}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span style="color: #6a7282;">Outstanding:</span>
              <span :style="{color: this.order.Amount > 0 ? '#f54a00': '#00a63e'}">€{{ Number(this.order.Amount).toFixed(2) }}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span style="color: #6a7282;">Status:</span>
              <span style="color: #334155; background-color: #f8fafc; border-color: #e2e8f0;" class="btn-selection" v-if="this.order.Status == 0">Created</span>
              <span style="border-color: #ffc9c9; background-color: #ffe2e2; color: #9f0712;" class="btn-selection" v-else-if="this.order.Status == 1">Not Reconciled</span>
              <span style="color: rgb(161, 98, 7); background-color: rgb(254, 252, 232); border-color: rgb(254, 240, 138);" class="btn-selection" v-else-if="this.order.Status == 2">Partially Paid</span>
              <span style="border-color: rgb(185, 248, 207); background-color: rgb(240, 253, 244); color: rgb(0, 130, 54);" class="btn-selection" v-else-if="this.order.Status == 3">Reconciled</span>
              <span v-else>—</span>
            </div>
          </div>
          <div style="display: grid; gap: 1rem;">
            <span style="display: flex; justify-content: baseline; font-weight: bold; font-size: 1.1rem;">Payment Details</span>
            <div style="display: flex; justify-content: space-between;">
              <span style="color: #6a7282;">VIBAN:</span>
              <span>{{ this.order.VIBAN == '$NotFound' || this.order.VIBAN == null ? '—' : this.order.VIBAN}}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span style="color: #6a7282;">Client Number:</span>
              <span>{{ this.order.Reference1 == '' ? this.order.PaymentGroupIdentifier2 : this.order.Reference1}}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span style="color: #6a7282;">Payments:</span>
              <span>{{ nbPayments }}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span style="color: #6a7282;">Reconciliations:</span>
              <span>{{ nbReconciled }}</span>
            </div>
          </div>
        </div>
        <div style="margin-top: 2rem;">
          <span style="display: flex; justify-content: baseline; font-weight: bold; font-size: 1.1rem;">Timeline & Logs</span>

          <div style="display: flex; gap: 1rem; margin-top: 1rem;">
            <div style="display: grid; gap: 0.35rem; justify-items: center;">
              <i v-if="this.order.Status == 3" style="background-color: #dbeafe; color: #155dfc; border-radius: 50%; padding: 1rem; font-size: 1.25rem;" class="fa-regular fa-clock"></i>
              <div v-if="this.order.Status == 3" style="border: 1px solid #ebe6e7; height: 2rem;"></div>
              <i style="background-color: #f6f3f4; color: #f54a00;border-radius: 50%; padding: 1rem; font-size: 1.25rem;" class="fa-regular fa-triangle-exclamation"></i>
              <div v-if="this.reconciliation && this.reconciliation.ReconciliationMode != 0" style="border: 1px solid #ebe6e7; height: 2rem;"></div>
              <i v-if="this.reconciliation && this.reconciliation.ReconciliationMode != 0" style="background-color: #dcfce7; color: #00a63e;border-radius: 50%; padding: 1rem; font-size: 1.25rem;" class="fa-regular fa-circle-check"></i>
            </div>
  
            <div style="display: grid; gap: 2rem; width: 100%;">
              <div v-if="this.order.Status == 3">
                <div style="display: flex; justify-content: space-between;">
                  <span style="font-weight: bold;">Payment Received</span>
                  <small>{{ new Date(this.order.PaymentGroupDate).toLocaleDateString() }} {{ new Date(this.order.PaymentGroupDate).toLocaleTimeString() }}</small>
                </div>
                <div style="display: flex;">
                  <span style="color: #6a7282;">Payment of €{{ Number(this.order.Amount).toFixed(2) }} received on VIBAN {{ this.order.VIBAN }}</span>
                </div>
              </div>

              <div>
                <div style="display: flex; justify-content: space-between;">
                  <span style="font-weight: bold;">Order Created</span>
                  <small v-if="this.order.Invoices[0]">{{ new Date(this.order.Invoices[0].InvoiceDate).toLocaleDateString() }} {{ new Date(this.order.Invoices[0].InvoiceDate).toLocaleTimeString() }}</small>
                </div>
                <div style="display: flex;">
                  <span style="color: #6a7282;">Order {{ this.order.Invoices[0] ? this.order.Invoices[0].InvoiceIdentifier : '' }} created for €{{ Number(this.order.Amount).toFixed(2) }}</span>
                </div>
              </div>
              
              <div v-if="this.reconciliation && this.reconciliation.ReconciliationMode != 0">
                <div style="display: flex; justify-content: space-between;">
                  <span style="font-weight: bold;">Payment Confirmed</span>
                  <small>{{ new Date(this.reconciliation.PaymentGroupDate).toLocaleDateString() }}</small>
                </div>
                <div style="display: flex;">
                  <span v-if="this.reconciliation.ReconciliationMode == 1" style="color: #6a7282;">AUTO reconciliation</span>
                  <span v-else style="color: #6a7282;">Manual reconciliation</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 2rem;" v-if="payments.length > 0">
          <span style="font-weight: bold; font-size: 1.1rem;">Payments</span>
          <b-table responsive hover rounded
            class="table-header-border rounded"
            style="margin-bottom:0; margin-top: 1rem;"
            :items="payments"
            :fields="fields"
            primary-key="id"
          >
            <template #cell(amount)="data">
                <span>
                  €{{ Number(data.item.Amount).toFixed(2) }}
                </span>
              </template>

            <template #cell(status)="data">
              <span style="color: #334155; background-color: #f8fafc; border-color: #e2e8f0;" class="btn-selection" v-if="data.item.Status == 0">Created</span>
              <span class="btn-selection" v-else-if="data.item.Status == 1">Not Reconciled</span>
              <span v-else-if="data.item.Status == 2">Partially Reconciled</span>
              <span style="border-color: #b9f8cf; background-color: #f0fdf4; color: #008236;" class="btn-selection" v-else-if="data.item.Status == 3">Reconciled</span>
            <span v-else>—</span>
            </template>


            <template #cell(date)="data">
              <span>{{  new Date(data.item.CreationDate).toLocaleString() }}</span>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    order: Object
  },
  name: 'ImportPaymentModal',
  data(){
    return {
      fields: [
        { key: 'amount', label: 'Amount', thClass: 'text-left align-middle border-bottom border-left border-top', tdClass: 'align-middle text-left font-weight-bold border-left border-bottom'},
        { key: 'date', label: 'Date', thClass: 'text-left align-middle border-bottom border-top', tdClass: 'align-middle text-left border-bottom'},
        { key: 'status', label: 'Status', thClass: 'text-left align-middle border-bottom  border-right border-top', tdClass: 'align-middle text-left border-right border-bottom'}
      ],
      isModalOpen: false,
      payments: [],
      nbReconciled : 0,
      nbPayments: 0,
      reconciliation: null
    }
  },
  methods: {
    openModal (){
      this.isModalOpen = true
       this.$engine.services.payments.getTransactions({Search: this.order.VIBAN, GetDetails: 1})
      .then(resp => {
        const data = resp.data
        this.payments = data.Transactions.filter(item=> item.Direction == 0)
        this.nbPayments = data.Transactions.filter(item=> item.Direction == 0).length
        this.nbReconciled = data.Transactions.filter(item=> item.Direction == 0 && item.ReconciliationMode != 0).length
        this.reconciliation = data.Transactions.filter(item=> item.Direction == 0 && item.ReconciliationMode != 0)[0]
      })
      .catch(err => {
        console.log(err)
      })
    },
    closeModal (){
      this.isModalOpen = false
    },
    sanitize(value) {
      if (typeof value !== 'string') return ''

      return value
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9-_]/g, '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/\r?\n|\r/g, '')
    },
    isoToDDMMYYYY (isoDate) {
      const [year, month, day] = isoDate.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
  }
}
</script>
<style scoped>

small{
  color: #6a7282;
  font-size: 0.85rem;
  margin: 0.25rem 0rem;
}

.btn-selection{
  font-weight: bold !important;
  display: flex;
  min-height: 0.5rem !important;
  gap: 1rem;
  padding: 0.25rem 0.5rem !important;
  align-items: center;
  border: 1px solid;
  border-radius: calc(0.75rem - 2px);
  font-size: 0.85rem;
  cursor: default !important;
}

.modal-container{
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  overflow: hidden;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content{
  overflow-y: scroll;
  max-height: 80vh;
}

.modal-content::-webkit-scrollbar {
  display: none;
}

.modal-content .filter-item {
  margin: 1rem 0rem;
}

.modal-content>h1{
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
}

.modal-content>h1>i{
  cursor: pointer;
}

.modal-content>input{
  margin-bottom: 1.5rem;
}

.modal-content>span:first-of-type{
  color: #717182;
  margin-bottom: 1rem;
}

.modal-content>span:last-of-type{
  color: #000;
  font-weight: bold;
}
</style>